export var ERoute;
(function (ERoute) {
    ERoute["BOOKCART"] = "/bookcart";
    ERoute["COURSES"] = "/courses";
    ERoute["SUCCESS"] = "/success";
    ERoute["PAYBOOK"] = "/paybook";
    ERoute["APPROVED"] = "/paybook/approved";
    ERoute["CANCELLED"] = "/paybook/cancelled";
    ERoute["BANK_TRANSFER"] = "/banktransfer";
    ERoute["CONSENTS"] = "/user/consents";
    ERoute["SEPA_DIRECT_DEBIT"] = "/sepadirectdebit";
    ERoute["CART"] = "/cart";
    ERoute["CHECKOUT"] = "/checkout";
    ERoute["OUTGOING_MESSAGES"] = "/user/outgoingmessages";
    ERoute["CANCEL_BOOKING"] = "/cancel";
    ERoute["CMS"] = "/cms/:model_name/:model_id";
    // Auth User
    ERoute["USER_ACCOUNT"] = "/user";
    ERoute["USER_BOOKINGS"] = "/user/bookings";
    ERoute["USER_BILLS"] = "/user/bills";
    ERoute["USER_MESSAGES"] = "/user/messages";
    ERoute["USER_PAYMENTS"] = "/user/payments";
})(ERoute || (ERoute = {}));
export var isSuccessRoute = function () {
    return (window.location.hash.startsWith("#" + ERoute.SUCCESS)
        || window.location.hash.startsWith("#" + ERoute.BANK_TRANSFER));
};
